import React, { useRef } from 'react';
import { toastContext } from '@shared/context/toastContext/toast-context';

export const ToastProvider: React.FC = ({ children }) => {
    const toastContainerRef = useRef<HTMLDivElement | null>(null);
    const setToastContainerRef = (ref: HTMLDivElement | null) => {
        toastContainerRef.current = ref;
    };
    return (
        <toastContext.Provider value={{ toastContainerRef, setToastContainerRef }}>{children}</toastContext.Provider>
    );
};
